import { useContext } from 'react';
import { SelectionContext } from '../GridDndEditor/SelectedBlockInfoProvider';
import { useNewBlockContentObjectChangedHandler } from './useNewBlockContentObjectChangedHandler';
import type { EmbedContent } from '../embed/embed';
import { useSelector } from 'react-redux';
import { selectBlockContent } from '../grid/reduxStore/editorSlice';
import type { RootState } from '../grid/reduxStore/Store';

export const useEmbedWithUndoRedoBlockSettings = () => {
  const { selectedBlockInfoByWrapper } = useContext(SelectionContext);
  const newContentObjectChanged = useNewBlockContentObjectChangedHandler();

  const blockId = selectedBlockInfoByWrapper.blockId as string;
  const sectionId = selectedBlockInfoByWrapper.sectionId as string;

  const blockContent = useSelector((state: RootState) => selectBlockContent(state, sectionId, blockId));

  const updateEmbedContent = async (content: EmbedContent) => {
    const oldContent = blockContent?.contentObject || {};
    await newContentObjectChanged(blockId, sectionId, oldContent, content);
  };

  return { updateEmbedContent };
};
